module.exports = __webpack_public_path__ + "img/retail_solution.82068e40.svg";